import React, { Component } from "react";
import Slider from "react-slick";

import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";

class FullPageImage extends Component {

    handleScroll = e => {
        const paget = document.getElementById("work").getBoundingClientRect().top;
        const pageb = document.getElementById("work").getBoundingClientRect().bottom;
        const sh = screen.availHeight;
    
        if (paget < sh) {
            if (screen.width > 768) {
                if (paget < sh-48 && paget > -10) {
                    this.props.onMenuToggleWhite(true);
                } else {
                    this.props.onMenuToggleWhite(false);
                }
                if (paget < 80+24 && pageb > 80+24) {
                    this.props.onLogoWhite(true);
                } else {
                    this.props.onLogoWhite(false);
                }
            }
        } else {this.props.onMenuToggleWhite(false);}
    };

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }
    
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

render (props) {
    var settings = {
        slidesToShow: 1,		  
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 500,
        dots: false,
        arrows: false,
        infinite: true,		 
        fade: true,  
      };
    return (
        <div id={this.props.id} className="h-screen w-full overflow-hidden -ml-6">
            <Slider {...settings}>
                <div className="aslide slide1"></div>
                <div className="aslide slide2"></div>
                <div className="aslide slide3"></div>
                <div className="aslide slide4"></div>
                <div className="aslide slide5"></div>
                <div className="aslide slide6"></div>
                <div className="aslide slide7"></div>
                <div className="aslide slide8"></div>
                <div className="aslide slide9"></div>
                <div className="aslide slide10"></div>
                <div className="aslide slide11"></div>
                <div className="aslide slide12"></div>
                <div className="aslide slide13"></div>
                <div className="aslide slide14"></div>
                <div className="aslide slide15"></div>
            </Slider>
        </div>
    )
}

};

export default FullPageImage;


// WEBPACK FOOTER //
// ./src/components/FullPageImage/fullPageImageOne.js